/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Instamouse API
 * REST API for Instamouse: launch, fork, and share browser-streamed xpra desktop machines. Generated client lives in the frontend (orval).
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  CreateMachineShareBody,
  ErrorResponse,
  ForkMachineBody,
  ForkResponseResponse,
  GetGuestMachine200,
  GetMachineShares200,
  GuestMachineLimitResponse,
  GuestReplaceBodyBody,
  MachineDetailResponse,
  MachineListResponse,
  MachineUpdate,
  MessageResponse,
  ShareLink,
  ToggleFavorite200,
  WssResponseResponse,
  XpraSessionDeadline,
  XpraSessionInfo
} from '../../model'
import { customFetch } from '../../../mutator/custom-fetch';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const getPromotedMachines = (
    
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<MachineListResponse>(
      {url: `/api/v1/machines/promoted`, method: 'GET', signal
    },
      options);
    }
  

export const getGetPromotedMachinesQueryKey = () => {
    return [`/api/v1/machines/promoted`] as const;
    }

    
export const getGetPromotedMachinesQueryOptions = <TData = Awaited<ReturnType<typeof getPromotedMachines>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromotedMachines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPromotedMachinesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPromotedMachines>>> = ({ signal }) => getPromotedMachines(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPromotedMachines>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPromotedMachinesQueryResult = NonNullable<Awaited<ReturnType<typeof getPromotedMachines>>>
export type GetPromotedMachinesQueryError = unknown

export const useGetPromotedMachines = <TData = Awaited<ReturnType<typeof getPromotedMachines>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromotedMachines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetPromotedMachinesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getMyMachines = (
    
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<MachineListResponse>(
      {url: `/api/v1/machines/mine`, method: 'GET', signal
    },
      options);
    }
  

export const getGetMyMachinesQueryKey = () => {
    return [`/api/v1/machines/mine`] as const;
    }

    
export const getGetMyMachinesQueryOptions = <TData = Awaited<ReturnType<typeof getMyMachines>>, TError = ErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyMachines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyMachinesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyMachines>>> = ({ signal }) => getMyMachines(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyMachines>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMyMachinesQueryResult = NonNullable<Awaited<ReturnType<typeof getMyMachines>>>
export type GetMyMachinesQueryError = ErrorResponse

export const useGetMyMachines = <TData = Awaited<ReturnType<typeof getMyMachines>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyMachines>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetMyMachinesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const quickstart = (
    guestReplaceBodyBody?: GuestReplaceBodyBody,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<ForkResponseResponse>(
      {url: `/api/v1/machines/quickstart`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: guestReplaceBodyBody
    },
      options);
    }
  


export const getQuickstartMutationOptions = <TError = GuestMachineLimitResponse | ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof quickstart>>, TError,{data: GuestReplaceBodyBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof quickstart>>, TError,{data: GuestReplaceBodyBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof quickstart>>, {data: GuestReplaceBodyBody}> = (props) => {
          const {data} = props ?? {};

          return  quickstart(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type QuickstartMutationResult = NonNullable<Awaited<ReturnType<typeof quickstart>>>
    export type QuickstartMutationBody = GuestReplaceBodyBody
    export type QuickstartMutationError = GuestMachineLimitResponse | ErrorResponse

    export const useQuickstart = <TError = GuestMachineLimitResponse | ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof quickstart>>, TError,{data: GuestReplaceBodyBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationResult<
        Awaited<ReturnType<typeof quickstart>>,
        TError,
        {data: GuestReplaceBodyBody},
        TContext
      > => {

      const mutationOptions = getQuickstartMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getGuestMachine = (
    
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<GetGuestMachine200>(
      {url: `/api/v1/machines/guest`, method: 'GET', signal
    },
      options);
    }
  

export const getGetGuestMachineQueryKey = () => {
    return [`/api/v1/machines/guest`] as const;
    }

    
export const getGetGuestMachineQueryOptions = <TData = Awaited<ReturnType<typeof getGuestMachine>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestMachine>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGuestMachineQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGuestMachine>>> = ({ signal }) => getGuestMachine(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGuestMachine>>, TError, TData> & { queryKey: QueryKey }
}

export type GetGuestMachineQueryResult = NonNullable<Awaited<ReturnType<typeof getGuestMachine>>>
export type GetGuestMachineQueryError = unknown

export const useGetGuestMachine = <TData = Awaited<ReturnType<typeof getGuestMachine>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestMachine>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetGuestMachineQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getMachine = (
    publicId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<MachineDetailResponse>(
      {url: `/api/v1/machines/${publicId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetMachineQueryKey = (publicId: string,) => {
    return [`/api/v1/machines/${publicId}`] as const;
    }

    
export const getGetMachineQueryOptions = <TData = Awaited<ReturnType<typeof getMachine>>, TError = ErrorResponse>(publicId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMachine>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMachineQueryKey(publicId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMachine>>> = ({ signal }) => getMachine(publicId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(publicId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMachine>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMachineQueryResult = NonNullable<Awaited<ReturnType<typeof getMachine>>>
export type GetMachineQueryError = ErrorResponse

export const useGetMachine = <TData = Awaited<ReturnType<typeof getMachine>>, TError = ErrorResponse>(
 publicId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMachine>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetMachineQueryOptions(publicId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const updateMachine = (
    publicId: string,
    machineUpdate: MachineUpdate,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<MachineDetailResponse>(
      {url: `/api/v1/machines/${publicId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: machineUpdate
    },
      options);
    }
  


export const getUpdateMachineMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMachine>>, TError,{publicId: string;data: MachineUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateMachine>>, TError,{publicId: string;data: MachineUpdate}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMachine>>, {publicId: string;data: MachineUpdate}> = (props) => {
          const {publicId,data} = props ?? {};

          return  updateMachine(publicId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateMachineMutationResult = NonNullable<Awaited<ReturnType<typeof updateMachine>>>
    export type UpdateMachineMutationBody = MachineUpdate
    export type UpdateMachineMutationError = ErrorResponse

    export const useUpdateMachine = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMachine>>, TError,{publicId: string;data: MachineUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateMachine>>,
        TError,
        {publicId: string;data: MachineUpdate},
        TContext
      > => {

      const mutationOptions = getUpdateMachineMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const deleteMachine = (
    publicId: string,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<MessageResponse>(
      {url: `/api/v1/machines/${publicId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteMachineMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMachine>>, TError,{publicId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteMachine>>, TError,{publicId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMachine>>, {publicId: string}> = (props) => {
          const {publicId} = props ?? {};

          return  deleteMachine(publicId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteMachineMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMachine>>>
    
    export type DeleteMachineMutationError = ErrorResponse

    export const useDeleteMachine = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMachine>>, TError,{publicId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteMachine>>,
        TError,
        {publicId: string},
        TContext
      > => {

      const mutationOptions = getDeleteMachineMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const forkMachine = (
    publicId: string,
    forkMachineBody?: ForkMachineBody,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<ForkResponseResponse>(
      {url: `/api/v1/machines/${publicId}/fork`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: forkMachineBody
    },
      options);
    }
  


export const getForkMachineMutationOptions = <TError = ErrorResponse | GuestMachineLimitResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof forkMachine>>, TError,{publicId: string;data: ForkMachineBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof forkMachine>>, TError,{publicId: string;data: ForkMachineBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof forkMachine>>, {publicId: string;data: ForkMachineBody}> = (props) => {
          const {publicId,data} = props ?? {};

          return  forkMachine(publicId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ForkMachineMutationResult = NonNullable<Awaited<ReturnType<typeof forkMachine>>>
    export type ForkMachineMutationBody = ForkMachineBody
    export type ForkMachineMutationError = ErrorResponse | GuestMachineLimitResponse

    export const useForkMachine = <TError = ErrorResponse | GuestMachineLimitResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof forkMachine>>, TError,{publicId: string;data: ForkMachineBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationResult<
        Awaited<ReturnType<typeof forkMachine>>,
        TError,
        {publicId: string;data: ForkMachineBody},
        TContext
      > => {

      const mutationOptions = getForkMachineMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const rejoinMachine = (
    publicId: string,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<WssResponseResponse>(
      {url: `/api/v1/machines/${publicId}/rejoin`, method: 'POST'
    },
      options);
    }
  


export const getRejoinMachineMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejoinMachine>>, TError,{publicId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rejoinMachine>>, TError,{publicId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejoinMachine>>, {publicId: string}> = (props) => {
          const {publicId} = props ?? {};

          return  rejoinMachine(publicId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RejoinMachineMutationResult = NonNullable<Awaited<ReturnType<typeof rejoinMachine>>>
    
    export type RejoinMachineMutationError = ErrorResponse

    export const useRejoinMachine = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejoinMachine>>, TError,{publicId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationResult<
        Awaited<ReturnType<typeof rejoinMachine>>,
        TError,
        {publicId: string},
        TContext
      > => {

      const mutationOptions = getRejoinMachineMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const connectAsGuest = (
    publicId: string,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<WssResponseResponse>(
      {url: `/api/v1/machines/${publicId}/connect`, method: 'POST'
    },
      options);
    }
  


export const getConnectAsGuestMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectAsGuest>>, TError,{publicId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof connectAsGuest>>, TError,{publicId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof connectAsGuest>>, {publicId: string}> = (props) => {
          const {publicId} = props ?? {};

          return  connectAsGuest(publicId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ConnectAsGuestMutationResult = NonNullable<Awaited<ReturnType<typeof connectAsGuest>>>
    
    export type ConnectAsGuestMutationError = ErrorResponse

    export const useConnectAsGuest = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectAsGuest>>, TError,{publicId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationResult<
        Awaited<ReturnType<typeof connectAsGuest>>,
        TError,
        {publicId: string},
        TContext
      > => {

      const mutationOptions = getConnectAsGuestMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getMachineShares = (
    publicId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<GetMachineShares200>(
      {url: `/api/v1/machines/${publicId}/shares`, method: 'GET', signal
    },
      options);
    }
  

export const getGetMachineSharesQueryKey = (publicId: string,) => {
    return [`/api/v1/machines/${publicId}/shares`] as const;
    }

    
export const getGetMachineSharesQueryOptions = <TData = Awaited<ReturnType<typeof getMachineShares>>, TError = ErrorResponse>(publicId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMachineShares>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMachineSharesQueryKey(publicId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMachineShares>>> = ({ signal }) => getMachineShares(publicId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(publicId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMachineShares>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMachineSharesQueryResult = NonNullable<Awaited<ReturnType<typeof getMachineShares>>>
export type GetMachineSharesQueryError = ErrorResponse

export const useGetMachineShares = <TData = Awaited<ReturnType<typeof getMachineShares>>, TError = ErrorResponse>(
 publicId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMachineShares>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetMachineSharesQueryOptions(publicId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const createMachineShare = (
    publicId: string,
    createMachineShareBody?: CreateMachineShareBody,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<ShareLink>(
      {url: `/api/v1/machines/${publicId}/shares`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createMachineShareBody
    },
      options);
    }
  


export const getCreateMachineShareMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMachineShare>>, TError,{publicId: string;data: CreateMachineShareBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createMachineShare>>, TError,{publicId: string;data: CreateMachineShareBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMachineShare>>, {publicId: string;data: CreateMachineShareBody}> = (props) => {
          const {publicId,data} = props ?? {};

          return  createMachineShare(publicId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateMachineShareMutationResult = NonNullable<Awaited<ReturnType<typeof createMachineShare>>>
    export type CreateMachineShareMutationBody = CreateMachineShareBody
    export type CreateMachineShareMutationError = ErrorResponse

    export const useCreateMachineShare = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMachineShare>>, TError,{publicId: string;data: CreateMachineShareBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationResult<
        Awaited<ReturnType<typeof createMachineShare>>,
        TError,
        {publicId: string;data: CreateMachineShareBody},
        TContext
      > => {

      const mutationOptions = getCreateMachineShareMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const revokeMachineShare = (
    publicId: string,
    shareId: string,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<MessageResponse>(
      {url: `/api/v1/machines/${publicId}/shares/${shareId}`, method: 'DELETE'
    },
      options);
    }
  


export const getRevokeMachineShareMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeMachineShare>>, TError,{publicId: string;shareId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof revokeMachineShare>>, TError,{publicId: string;shareId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeMachineShare>>, {publicId: string;shareId: string}> = (props) => {
          const {publicId,shareId} = props ?? {};

          return  revokeMachineShare(publicId,shareId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RevokeMachineShareMutationResult = NonNullable<Awaited<ReturnType<typeof revokeMachineShare>>>
    
    export type RevokeMachineShareMutationError = ErrorResponse

    export const useRevokeMachineShare = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeMachineShare>>, TError,{publicId: string;shareId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationResult<
        Awaited<ReturnType<typeof revokeMachineShare>>,
        TError,
        {publicId: string;shareId: string},
        TContext
      > => {

      const mutationOptions = getRevokeMachineShareMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const shutdownMachine = (
    publicId: string,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<MessageResponse>(
      {url: `/api/v1/machines/${publicId}/shutdown`, method: 'POST'
    },
      options);
    }
  


export const getShutdownMachineMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shutdownMachine>>, TError,{publicId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof shutdownMachine>>, TError,{publicId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof shutdownMachine>>, {publicId: string}> = (props) => {
          const {publicId} = props ?? {};

          return  shutdownMachine(publicId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ShutdownMachineMutationResult = NonNullable<Awaited<ReturnType<typeof shutdownMachine>>>
    
    export type ShutdownMachineMutationError = ErrorResponse

    export const useShutdownMachine = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shutdownMachine>>, TError,{publicId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationResult<
        Awaited<ReturnType<typeof shutdownMachine>>,
        TError,
        {publicId: string},
        TContext
      > => {

      const mutationOptions = getShutdownMachineMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const joinMachineShare = (
    publicId: string,
    code: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<WssResponseResponse>(
      {url: `/api/v1/machines/${publicId}/share/${code}`, method: 'GET', signal
    },
      options);
    }
  

export const getJoinMachineShareQueryKey = (publicId: string,
    code: string,) => {
    return [`/api/v1/machines/${publicId}/share/${code}`] as const;
    }

    
export const getJoinMachineShareQueryOptions = <TData = Awaited<ReturnType<typeof joinMachineShare>>, TError = ErrorResponse>(publicId: string,
    code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof joinMachineShare>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getJoinMachineShareQueryKey(publicId,code);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof joinMachineShare>>> = ({ signal }) => joinMachineShare(publicId,code, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(publicId && code), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof joinMachineShare>>, TError, TData> & { queryKey: QueryKey }
}

export type JoinMachineShareQueryResult = NonNullable<Awaited<ReturnType<typeof joinMachineShare>>>
export type JoinMachineShareQueryError = ErrorResponse

export const useJoinMachineShare = <TData = Awaited<ReturnType<typeof joinMachineShare>>, TError = ErrorResponse>(
 publicId: string,
    code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof joinMachineShare>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getJoinMachineShareQueryOptions(publicId,code,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getXpraSession = (
    nonce: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<XpraSessionInfo>(
      {url: `/api/v1/xpra/${nonce}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetXpraSessionQueryKey = (nonce: string,) => {
    return [`/api/v1/xpra/${nonce}`] as const;
    }

    
export const getGetXpraSessionQueryOptions = <TData = Awaited<ReturnType<typeof getXpraSession>>, TError = ErrorResponse>(nonce: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getXpraSession>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetXpraSessionQueryKey(nonce);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getXpraSession>>> = ({ signal }) => getXpraSession(nonce, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(nonce), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getXpraSession>>, TError, TData> & { queryKey: QueryKey }
}

export type GetXpraSessionQueryResult = NonNullable<Awaited<ReturnType<typeof getXpraSession>>>
export type GetXpraSessionQueryError = ErrorResponse

export const useGetXpraSession = <TData = Awaited<ReturnType<typeof getXpraSession>>, TError = ErrorResponse>(
 nonce: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getXpraSession>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetXpraSessionQueryOptions(nonce,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getXpraSessionDeadline = (
    nonce: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<XpraSessionDeadline>(
      {url: `/api/v1/xpra/${nonce}/deadline`, method: 'GET', signal
    },
      options);
    }
  

export const getGetXpraSessionDeadlineQueryKey = (nonce: string,) => {
    return [`/api/v1/xpra/${nonce}/deadline`] as const;
    }

    
export const getGetXpraSessionDeadlineQueryOptions = <TData = Awaited<ReturnType<typeof getXpraSessionDeadline>>, TError = ErrorResponse>(nonce: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getXpraSessionDeadline>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetXpraSessionDeadlineQueryKey(nonce);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getXpraSessionDeadline>>> = ({ signal }) => getXpraSessionDeadline(nonce, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(nonce), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getXpraSessionDeadline>>, TError, TData> & { queryKey: QueryKey }
}

export type GetXpraSessionDeadlineQueryResult = NonNullable<Awaited<ReturnType<typeof getXpraSessionDeadline>>>
export type GetXpraSessionDeadlineQueryError = ErrorResponse

export const useGetXpraSessionDeadline = <TData = Awaited<ReturnType<typeof getXpraSessionDeadline>>, TError = ErrorResponse>(
 nonce: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getXpraSessionDeadline>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetXpraSessionDeadlineQueryOptions(nonce,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const toggleFavorite = (
    publicId: string,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<ToggleFavorite200>(
      {url: `/api/v1/machines/${publicId}/favorite`, method: 'POST'
    },
      options);
    }
  


export const getToggleFavoriteMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleFavorite>>, TError,{publicId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof toggleFavorite>>, TError,{publicId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof toggleFavorite>>, {publicId: string}> = (props) => {
          const {publicId} = props ?? {};

          return  toggleFavorite(publicId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ToggleFavoriteMutationResult = NonNullable<Awaited<ReturnType<typeof toggleFavorite>>>
    
    export type ToggleFavoriteMutationError = ErrorResponse

    export const useToggleFavorite = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleFavorite>>, TError,{publicId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationResult<
        Awaited<ReturnType<typeof toggleFavorite>>,
        TError,
        {publicId: string},
        TContext
      > => {

      const mutationOptions = getToggleFavoriteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    